export default {"src":"/_next/static/media/prev.bf382b2a.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};